export default (str, n) => 
    (str.length > n) ? str.substr(0, n-'...'.length) + '...' : str;
